import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, LocaleX, NavX, ReqX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, VStack, XButton, XText } from "IZOX/_X";
import { withRouter } from "react-router-dom/cjs/react-router-dom";

/**
 * @augments {Component<Props, State>}
 */
class PIPolicy extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      count: {
        Total: 0,
        Pending: 0,
        Active: 0,
        ExpirySoon: 0,
        Expired: 0,
        Renewed: 0,
        Canceled: 0
      }
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this.GetCount();
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PIPolicy.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _toPage = (tab) => {
    let {history} = this.props;
    NavX.Goto(history, `/Insurer/AllPolicies?status=${tab}`, false, true);
  }

  GetCount = async () => {
    let res = await ReqX.SendBE("/Web/Insurer/CountPolicies");
    let {Success, payload} = res;
    if(Success){
      this.setState({
        count: payload
      });
    }
  }

  renderBox(count, desc, color, bgColor, funcName){
    return (
      <XButton color={color} bgColor={bgColor} 
        style={{boxShadow: `0px 1px 2px 2px ${ColorX.CSS("lightGrey", 0.5)}`}}
        width={105} height={88}
        onPress={() => this._toPage(funcName)}>
        <XText bold fontSize={16}>
          {count}
        </XText>
        <XText fontSize={14}>
          {LocaleX.Parse(desc)}
        </XText>
      </XButton>
    );
  }

  render(){
    let {count} = this.state;
    let {Total, Pending, Active, ExpirySoon, Expired, Renewed, Canceled} = count ?? {};
    return (
      <VStack width={157} bgColor={ColorX.CSS("pureWhite")} pV={16}
        spacing={16} fullHeight>
        <HStack pH={16}>
          <XText color={ColorX.CSS("Leaf")} fontSize={14} bold>
            {LocaleX.Parse({
              EN: `Policies overview (${Total})`,
              TC: `保單概覽 (${Total})`
            })}
          </XText>
        </HStack>
        {this.renderBox(Pending, 
          {
            EN: "Pending",
            TC: "處理中"
          }, ColorX.CSS("Pending"), ColorX.CSS("PendingBg"), "Pending")}
        {this.renderBox(Active, 
          {
            EN: "Active",
            TC: "生效中"
          }, ColorX.CSS("Active"), ColorX.CSS("ActiveBg"), "Active")}
        {this.renderBox(ExpirySoon, 
          {
            EN: "Expiry Soon",
            TC: "即將過期"
          }, ColorX.CSS("ExpireSoon"), ColorX.CSS("ExpireSoonBg"), "ExpirySoon")}
        {this.renderBox(Expired, 
          {
            EN: "Expired",
            TC: "已過期"
          }, ColorX.CSS("Expired"), ColorX.CSS("ExpiredBg"), "Expired")}
        {this.renderBox(Renewed, 
          {
            EN: "Renewed",
            TC: "已更新"
          }, ColorX.CSS("Renewed"), ColorX.CSS("RenewedBg"), "Renewed")}
        {this.renderBox(Canceled, 
          {
            EN: "Canceled",
            TC: "已取消"
          }, ColorX.CSS("Canceled"), ColorX.CSS("CanceledBg"), "Canceled")}
      </VStack>
    );
  }

}

export default withRouter(observer(PIPolicy));
